import { render } from "./ModalAllBranches.vue?vue&type=template&id=4ec4e303&scoped=true&ts=true"
import script from "./ModalAllBranches.vue?vue&type=script&lang=ts"
export * from "./ModalAllBranches.vue?vue&type=script&lang=ts"

import "./ModalAllBranches.vue?vue&type=style&index=0&id=4ec4e303&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec4e303"]])

export default __exports__